export default {
  sm: `
  Louvers for 
  shading from the sun
  `
};
